import React from 'react'

export const CheckmarkIcon = (color = '#005BC7', width = 24, height = 24) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g>
        <path
          d="M12 23L4.8 17.6C4.55 17.4167 4.35417 17.1833 4.2125 16.9C4.07083 16.6167 4 16.3167 4 16V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.3167 19.9292 16.6167 19.7875 16.9C19.6458 17.1833 19.45 17.4167 19.2 17.6L12 23ZM12 20.5L18 16V4H6V16L12 20.5ZM10.95 15L16.6 9.35L15.2 7.9L10.95 12.15L8.85 10.05L7.4 11.45L10.95 15Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
